import type { CSSProperties } from 'react';
import type { IBufferingWheelProps } from './BufferingWheel.interface';
import styles from './BufferingWheel.module.css';

/* MUST match --spinner-width defined in BufferingWheel.module.css */
const SPINNER_WIDTH = '10vmin';

export enum StyleElem {
    Container = 'Container',
    Spinner = 'Spinner',
    Text = 'Text',
}

const DEFAULTS: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Spinner]: {},
    [StyleElem.Text]: {},
};

const PROPS_APPLICATOR: Record<StyleElem, (props: IBufferingWheelProps) => CSSProperties> = {
    [StyleElem.Container]: () => ({}),
    [StyleElem.Spinner]: (props: IBufferingWheelProps) => ({
        borderBottom: `0.8vmin solid ${props.spinnerColor}`,
        top: props.isVideo
            ? `calc(50% - ${SPINNER_WIDTH} / 2)`
            : `calc(70% - ${SPINNER_WIDTH} / 2)`,
    }),
    [StyleElem.Text]: (props: IBufferingWheelProps) => ({
        color: props.bufferingText?.color,
        fontWeight: props.bufferingText?.fontWeight,
        fontFamily: props.bufferingText?.fontFamily,
        fontSize: props.bufferingText?.fontSize,
        lineHeight: props.bufferingText?.fontSize,
    }),
};

export function classNameForElement(element: StyleElem, props: IBufferingWheelProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad || '';
}

export function styleForElement(element: StyleElem, props: IBufferingWheelProps): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](props) };

    return style;
}
